<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col
            cols="8"
            offset-md="2"
          >
            <h4>Filter</h4>
            <b-form
              class="needs-validation"
              @submit.prevent="submitFilter"
            >
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Tahun"
                    label-for="tahunFilter"
                  >
                    <b-form-select
                      id="tahunFilter"
                      v-model="tahunFilter"
                      :options="dataTahun"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Versi"
                    label-for="versiFilter"
                  >
                    <b-form-select
                      id="versiFilter"
                      v-model="versiFilter"
                      :options="dataVersi"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Wilayah"
                    label-for="wilayahFilter"
                  >
                    <b-form-select
                      id="wilayahFilter"
                      v-model="wilayahFilter"
                      :options="dataWilayah"
                      :disabled="!$can('Filter', 'cetakDaftarBmd')"
                      @change="changeWilayah"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="KIB"
                    label-for="kibFilter"
                  >
                    <b-form-select
                      id="kibFilter"
                      v-model="kibFilter"
                      :options="dataKib"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="PD/UPD"
                    label-for="pdUpdFilter"
                  >
                    <v-select
                      id="kolok"
                      v-model="pdUpdFilterValue"
                      label="text"
                      :options="dataPdUpd"
                      :disabled="!$can('Filter', 'cetakDaftarBmd')"
                      @search="searchPdUpd"
                      @input="inputPdUpd"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-col
                cols="12"
                class="mt-2"
              >
                <!-- table -->
                <b-row>
                  <b-col
                    cols="6"
                    align="right"
                  >
                    <b-button
                      size="large"
                      class="mb-2"
                      variant="danger"
                      :disabled="!kibFilter"
                      @click="clickPdf"
                    >
                      <b-icon
                        icon="file-earmark-text"
                        style="width: 100px; height: 100px"
                      />
                    </b-button>
                  </b-col>
                  <b-col cols="6">
                    <b-button
                      size="large"
                      class="mb-2"
                      variant="success"
                      :disabled="!kibFilter"
                      @click="clickExcel"
                    >
                      <b-icon
                        icon="file-earmark-excel"
                        style="width: 100px; height: 100px"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-form>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BForm,
  BIcon,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import vSelect from 'vue-select'
import master from '@/composables/master'
import { generateYears, startYear } from '@/libs/helper'

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')

    const tahunFilter = ref($route.query.tahun || year)
    const versiFilter = ref($route.query.versi || 'Transitoris')
    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({ text: '-- Semua --', value: '' })
    const kibFilter = ref($route.query.kib || 'C')
    const pencarianFilter = ref($route.query.pencarian || '')
    const provinsiFilter = ref($route.query.provinsi || '')
    const wilayahFilter = ref($route.query.wilayah || '')
    const kecamatanFilter = ref($route.query.kecamatan || '')
    const kelurahanFilter = ref($route.query.kelurahan || '')

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    }

    const dataTahun = ref(generateYears(startYear, year))
    const dataVersi = ref([{ value: 'Transitoris', text: 'Transitoris' }])
    const dataProvinsi = ref([{ text: '-- Semua --', value: '' }])
    const dataWilayah = ref([{ text: '-- Semua --', value: '' }])
    const dataKecamatan = ref([])
    const dataKelurahan = ref([])
    const dataPdUpd = ref([{ text: '-- Semua --', value: '' }])
    const dataKib = ref([{ text: '-- Pilih Salah Satu --', value: '' }])

    const clickExcel = async () => {
      window.open(
        `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/list-bmd?filter_kib=${kibFilter.value}&filter_tahun=${tahunFilter.value}&filter_upd=${pdUpdFilter.value}&length=1000000&format=excel`,
        '_blank',
      )
    }

    const clickPdf = async () => {
      window.open(
        `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/list-bmd?filter_kib=${kibFilter.value}&filter_tahun=${tahunFilter.value}&filter_upd=${pdUpdFilter.value}&length=1000000&format=pdf`,
        '_blank',
      )
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getKib = async () => {
      const resKib = await master.getKib(g)
      resKib.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataKib.value = resKib
    }

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Semua --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Semua --', value: '' }
      }
      getPdUpd()
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) { pdUpdFilter.value = pdUpdFilterValue.value.value }
    }

    getKib()
    getWilayah()
    getPdUpd()

    return {
      tahunFilter,
      versiFilter,
      pdUpdFilter,
      kibFilter,
      pencarianFilter,
      provinsiFilter,
      wilayahFilter,
      kecamatanFilter,
      kelurahanFilter,
      pdUpdFilterValue,
      dataTahun,
      dataVersi,
      dataPdUpd,
      dataKib,
      dataProvinsi,
      dataWilayah,
      dataKecamatan,
      dataKelurahan,
      clickExcel,
      clickPdf,
      searchPdUpd,
      changeWilayah,
      inputPdUpd,
    }
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BForm,
    BIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      columns: [
        {
          label: 'No',
          field: 'no',
          width: '1%',
        },
        {
          label: 'Kode',
          field: 'kode',
        },
        {
          label: 'Url',
          field: 'url',
        },
        {
          label: 'Aksi',
          field: 'aksi',
          width: '1%',
          sortable: false,
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
